import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBarChart2, FiCheck, FiEye, FiEyeOff, FiLock, FiMail } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import asderLogo from '../images/asderrLogo.png';


const ROLE_REDIRECT = {
  kurucu: '/admin/dashboard',
  ogrenci_isleri: '/admin/dashboard',
  ogretmen: '/ogretmen/dashboard',
  rehber_ogretmen: '/rehber/dashboard',
  veli: '/veli/dashboard',
  ogrenci: '/ogrenci/dashboard',
  muhasebe: '/muhasebe/dashboard',
};

function AsderBrand({ small = false }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: small ? 12 : 20 }}>
      <img
        src={asderLogo}
        alt="ASDER Sistem Logo"
        style={{
          width: small ? 64 : 82,
          height: small ? 64 : 82,
          objectFit: 'contain',
          filter: 'drop-shadow(0 10px 18px rgba(2,22,62,0.12))',
        }}
      />
      <div>
        <div style={{
          color: '#0d63f3',
          fontFamily: 'var(--font-ui)',
          fontSize: small ? 18 : 22,
          fontWeight: 900,
          letterSpacing: '-0.02em',
          lineHeight: 1,
        }}>
          ASDER Sistem
        </div>
        <div style={{
          marginTop: small ? 8 : 9,
          color: '#496084',
          fontSize: small ? 9 : 11,
          fontWeight: 800,
          letterSpacing: '0.09em',
          textTransform: 'uppercase',
        }}>
          Akademik Yönetim Sistemi
        </div>
      </div>
    </div>
  );
}

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'ASDER Sistem';
    return () => {
      document.title = prevTitle;
    };
  }, []);

  const handleLogin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!email.trim() || !sifre.trim()) {
      toast.error('E-posta ve şifre gerekli');
      return;
    }
    setLoading(true);
    const result = await login(email.trim(), sifre);
    setLoading(false);
    if (result.success) {
      toast.success('Hoş geldiniz!');
      navigate(ROLE_REDIRECT[result.user?.rol] || '/admin/dashboard');
    } else {
      toast.error(result.message || 'Giriş başarısız');
    }
  };


  const inputIconStyle = {
    position: 'absolute',
    left: 18,
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#5d6f91',
    fontSize: 20,
    pointerEvents: 'none',
  };

  return (
    <main style={{
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
      background: 'linear-gradient(135deg, #f7fbff 0%, #ffffff 45%, #eef6ff 100%)',
      color: '#061844',
      fontFamily: 'var(--font-ui)',
    }}>
      <div style={{ position: 'absolute', top: -190, left: -110, width: 360, height: 360, borderRadius: '50%', background: '#e7f3ff' }} />
      <div style={{ position: 'absolute', top: 34, left: 190, display: 'grid', gridTemplateColumns: 'repeat(3, 9px)', gap: 18, opacity: 0.42 }}>
        {Array.from({ length: 9 }).map((_, i) => <span key={i} style={{ width: 9, height: 9, borderRadius: '50%', background: '#8cbcf4' }} />)}
      </div>
      <div style={{ position: 'absolute', right: '43%', bottom: 78, width: 240, height: 240, borderRadius: '50%', border: '3px dashed rgba(83,157,232,0.24)', borderLeftColor: 'transparent', borderBottomColor: 'transparent', transform: 'rotate(26deg)' }} />
      <div style={{ position: 'absolute', right: '42%', bottom: 224, width: 18, height: 18, borderRadius: '50%', background: '#f2a900' }} />
      <div style={{ position: 'absolute', left: isMobile ? '10%' : '39%', bottom: 84, width: 82, height: 82, background: 'rgba(42,126,231,0.16)', clipPath: 'polygon(0 26%, 100% 0, 75% 100%)', transform: 'rotate(16deg)' }} />
      {!isMobile && (
        <div style={{ position: 'absolute', left: '36%', bottom: 96, width: 270, height: 170, pointerEvents: 'none' }}>
          {[70, 132, 194, 256].map((x, i) => (
            <span key={x} style={{
              position: 'absolute',
              left: x,
              bottom: 0,
              width: 54,
              height: 58 + i * 34,
              borderRadius: 8,
              background: 'linear-gradient(180deg, rgba(99,161,235,0.30), rgba(99,161,235,0.04))',
            }} />
          ))}
          <span style={{ position: 'absolute', left: 0, bottom: 28, width: 280, height: 30, borderRadius: 999, background: 'rgba(69,136,220,0.16)', transform: 'rotate(-28deg)', transformOrigin: 'right center' }} />
        </div>
      )}

      <div style={{
        position: 'relative',
        zIndex: 1,
        minHeight: '100vh',
        display: isMobile ? 'flex' : 'grid',
        flexDirection: isMobile ? 'column' : undefined,
        gridTemplateColumns: isMobile ? undefined : 'minmax(0, 1fr) 420px',
        gap: isMobile ? 24 : 28,
        alignItems: 'center',
        justifyContent: isMobile ? 'flex-start' : 'center',
        padding: isMobile ? '16px 16px 60px' : '20px 30px 70px 40px',
      }}>
        {/* Giriş Bölümü — Mobilde sayfanın tam ortasında ilk görünen bölüm */}
        <aside style={{
          width: '100%',
          maxWidth: isMobile ? 440 : 'none',
          margin: isMobile ? '0 auto' : 0,
          minHeight: isMobile ? 'calc(100dvh - 32px)' : 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: isMobile ? '28px 20px' : '30px 34px',
          borderRadius: isMobile ? 20 : 14,
          background: 'rgba(255,255,255,0.88)',
          border: '1px solid rgba(222,229,239,0.92)',
          boxShadow: '0 22px 54px rgba(8,36,76,0.14)',
          backdropFilter: 'blur(18px)',
          boxSizing: 'border-box',
          order: isMobile ? 1 : 2,
        }}>
          {isMobile && (
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 22 }}>
              <AsderBrand small />
            </div>
          )}

          <div style={{ marginBottom: 22 }}>
            <h2 style={{ margin: 0, color: '#061844', fontSize: isMobile ? 26 : 30, fontWeight: 900, letterSpacing: '-0.02em' }}>Giriş Yap</h2>
            <p style={{ margin: '8px 0 0', color: '#53698d', fontSize: 14 }}>Hesabınıza erişmek için bilgilerinizi girin</p>
          </div>

          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <div>
              <label className="form-label" style={{ color: '#061844', fontSize: 13, fontWeight: 900, marginBottom: 7 }}>E-posta</label>
              <div style={{ position: 'relative' }}>
                <FiMail style={inputIconStyle} />
                <input
                  type="email"
                  className="form-input"
                  placeholder="ornek@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  autoComplete="email"
                  style={{ height: 46, paddingLeft: 46, borderRadius: 9, background: 'rgba(255,255,255,0.68)', borderColor: '#cfd8e6' }}
                />
              </div>
            </div>
            <div>
              <label className="form-label" style={{ color: '#061844', fontSize: 13, fontWeight: 900, marginBottom: 7 }}>Şifre</label>
              <div style={{ position: 'relative' }}>
                <FiLock style={inputIconStyle} />
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-input"
                  placeholder="••••••••"
                  value={sifre}
                  onChange={e => setSifre(e.target.value)}
                  autoComplete="current-password"
                  style={{ height: 46, paddingLeft: 46, paddingRight: 48, borderRadius: 9, background: 'rgba(255,255,255,0.68)', borderColor: '#cfd8e6' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(v => !v)}
                  aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
                  style={{
                    position: 'absolute',
                    right: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 6,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: showPassword ? '#0d63f3' : '#5d6f91',
                    fontSize: 20,
                  }}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              style={{
                width: '100%',
                height: 46,
                justifyContent: 'center',
                marginTop: 0,
                borderRadius: 10,
                background: 'linear-gradient(135deg, #f3122d, #de0625)',
                boxShadow: '0 16px 30px rgba(237,27,53,0.24)',
                fontSize: 15,
                fontWeight: 900,
              }}
              disabled={loading}
            >
              {loading ? (
                <><div className="spinner" style={{ width: 15, height: 15 }} />&nbsp;Giriş yapılıyor...</>
              ) : 'Giriş Yap →'}
            </button>
          </form>

          {isMobile && (
            <div style={{
              textAlign: 'center',
              marginTop: 24,
              fontSize: 12,
              fontWeight: 600,
              color: '#5d6f91',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
              opacity: 0.85
            }}>
              <span>Özellikler ve detaylar için aşağı kaydırın</span>
              <span style={{ fontSize: 14 }}>↓</span>
            </div>
          )}
        </aside>

        {/* Tanıtım / Özellikler Bölümü — Mobilde aşağı kaydırınca görünür, masaüstünde solda */}
        <section style={{
          maxWidth: isMobile ? 440 : 780,
          width: '100%',
          margin: isMobile ? '24px auto 0' : 0,
          order: isMobile ? 2 : 1,
        }}>
          {!isMobile && (
            <div style={{
              display: 'inline-flex',
              marginBottom: 26,
            }}>
              <div style={{
                padding: '16px 26px',
                borderRadius: 22,
                background: 'rgba(255,255,255,0.85)',
                border: '1px solid rgba(214, 226, 242, 0.8)',
                boxShadow: '0 18px 44px rgba(30,73,120,0.08)',
              }}>
                <AsderBrand small={false} />
              </div>
            </div>
          )}

          <h1 style={{
            margin: 0,
            color: '#061844',
            fontSize: isMobile ? 32 : 40,
            lineHeight: 1.1,
            fontWeight: 900,
            letterSpacing: '-0.02em',
          }}>
            Öğrencilerin<br />
            <span style={{ color: '#ed1b35', fontStyle: 'italic' }}>başarısı</span> için
          </h1>
          <p style={{
            margin: isMobile ? '14px 0 22px' : '14px 0 24px',
            color: '#455b80',
            fontSize: isMobile ? 14 : 15,
            lineHeight: 1.7,
            maxWidth: 640,
          }}>
            Yoklama, deneme analizi, rehberlik görüşmeleri ve daha fazlası<br />
            — tüm yönetim araçları tek platformda.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(86px, 150px))',
            gap: isMobile ? 12 : 22,
            marginBottom: isMobile ? 22 : 22,
          }}>
            {[['7', 'Rol'], ['60+', 'API'], ['∞', 'Öğrenci']].map(([n, l], i) => (
              <div key={l} style={{
                borderRight: !isMobile && i < 2 ? '1px solid #d6deea' : 'none',
                minHeight: 54,
              }}>
                <div style={{ color: '#ed1b35', fontSize: isMobile ? 26 : 30, fontWeight: 900, lineHeight: 1 }}>{n}</div>
                <div style={{ marginTop: 6, color: '#52698d', fontSize: 13, fontWeight: 500 }}>{l}</div>
              </div>
            ))}
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(260px, 1fr))',
            gap: 14,
            maxWidth: 700,
          }}>
            {[
              { t: 'Canlı Takip', d: 'Yoklama, ödev ve deneme süreçlerini tek ekranda takip edin.', icon: <FiBarChart2 /> },
              { t: 'Hızlı Karar', d: 'Ölçme sonuçlarıyla doğru öğrencide doğru aksiyonu alın.', icon: <FiCheck /> },
            ].map((item, idx) => (
              <div key={item.t} style={{
                display: 'grid',
                gridTemplateColumns: '42px 1fr',
                gap: 12,
                alignItems: 'center',
                padding: '14px 16px',
                borderRadius: 14,
                background: 'rgba(255,255,255,0.82)',
                border: '1px solid rgba(202,214,231,0.84)',
                boxShadow: '0 14px 34px rgba(26,63,108,0.09)',
              }}>
                <div style={{
                  width: 42,
                  height: 42,
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  color: idx === 0 ? '#1266f1' : '#04b878',
                  background: idx === 0 ? '#eaf3ff' : '#dff8ec',
                  fontSize: 20,
                }}>
                  {item.icon}
                </div>
                <div>
                  <div style={{ color: '#1266f1', fontSize: 15, fontWeight: 900 }}>{item.t}</div>
                  <div style={{ marginTop: 5, color: '#40577b', fontSize: 13, lineHeight: 1.42 }}>{item.d}</div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {!isMobile && (
        <footer style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
          height: 78,
          color: '#fff',
          background: '#062653',
          clipPath: 'ellipse(82% 70% at 54% 100%)',
        }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 24,
            width: 280,
            height: 28,
            background: '#f7aa00',
            transform: 'rotate(9deg)',
            transformOrigin: 'left center',
          }} />
          <div style={{
            position: 'absolute',
            right: 48,
            bottom: 14,
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '6px 14px',
            borderRadius: 10,
            background: '#ffffff',
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
          }}>
            <img src={asderLogo} alt="ASDER Sistem" style={{ width: 26, height: 26, objectFit: 'contain' }} />
            <span style={{ color: '#0d63f3', fontWeight: 800, fontSize: 13, letterSpacing: '-0.01em' }}>ASDER Sistem</span>
          </div>
        </footer>
      )}
    </main>
  );
}
